module.exports = __webpack_public_path__ + "img/icon_.bbdb5d8e.png";